import { TabProps } from '@mui/material';
import { StyledTab, TabCounter } from './styled';

export interface TopTabItemProps extends Omit<TabProps, 'label'> {
  label: string;
  count?: number;
  hideCount?: boolean;
}

const TopTabItem = (props: TopTabItemProps) => {
  const { count = 0, label, hideCount, ...rest } = props;
  const labelContent = (
    <>
      {label}
      {!hideCount && <TabCounter>{count}</TabCounter>}
    </>
  );

  return <StyledTab iconPosition="start" label={labelContent} {...rest} />;
};

export default TopTabItem;
